import ModelFactoryChoice, {IModelFactoryChoices} from "./ModelFactoryChoice";
import ModelFactoryService from "./ModelFactoryService";
import BasicModelFactory from "./BasicModelFactory";
import {FactoryID} from "../type-interface/ModelFactoryType";
import {IPopulateIDs} from "../type-interface/ModelFactoryInterface";
import {getModelFactory} from "../ModelFactory";
import {NavigationLevelVO} from "../../manager/navigation/NavigationModel";
import {keyCount} from "../../common/SiteHelper";
import {IFactoryData} from "./ModelFactoryInterface";

export default class ModelFactoryModel implements IFactoryData
{
    id: string;
    factoryID: FactoryID = "none";
    choices: IModelFactoryChoices = {};
    choiceOrder: string[] = [];
    populateIDs: IPopulateIDs = {};
    activeChoiceList: ModelFactoryChoice[]|null = null;
    destroyed:boolean = false;


    constructor(id: string)
    {
        this.id = id;
    }

    choiceList(choiceOrder?:string[]): ModelFactoryChoice[]
    {
        if(choiceOrder){
            return this.service().createChoiceList(this.choices, choiceOrder);
        }
        if(!this.activeChoiceList){
            this.activeChoiceList = this.service().createChoiceList(this.choices, this.choiceOrder);
        }
        return this.activeChoiceList;
    }

    resetChoiceList(): void
    {
        this.clearChoiceList();
    }

    clearChoiceList(): void
    {
        this.choices = {};
        this.choiceOrder.length = 0;
        this.clearActiveChoiceList();
    }


    addChoice(choice:ModelFactoryChoice): void
    {
        this.clearActiveChoiceList();
        this.choices[choice.id] = choice;
        if(!this.choiceOrder.includes(choice.id)){
            this.choiceOrder.push(choice.id);
        }
        this.applyChoice(choice);
    }

    clearActiveChoiceList(): void
    {
        this.activeChoiceList = null;
    }

    getDerivedModels(): ModelFactoryModel[]
    {
        return [];
    }


    applyModelConditions (): void
    {

    }

    onModelConditionsApplied (): void
    {
        this.initChoiceOrder();
        if(keyCount(this.choices) === 0 && this.choiceOrder.length > 0){
            const factory = this.factory();
            if(factory){
                const choices = this.cloneChoices(factory.choices, this.choiceOrder);
                for(let i = 0; i < this.choiceOrder.length; i++){
                    const choiceID = this.choiceOrder[i];
                    const choice = choices[choiceID];
                    if(choice){
                        choice.id = choiceID;
                        this.addChoice(choice);
                    }
                }
            }
        }
        this.requireChoiceOrder();
    }

    cloneChoices = (fromChoices:IModelFactoryChoices, choiceOrder?: string[]): IModelFactoryChoices => {
        if(!choiceOrder){
            choiceOrder = [];
            for(let choiceID in fromChoices){
                choiceOrder.push(choiceID);
            }
        }
        const choices:IModelFactoryChoices = {};
        for(let i = 0; i < choiceOrder.length; i ++){
            const choiceID = choiceOrder[i];
            const choice = fromChoices[choiceID];
            if(choice){
                choices[choiceID] = this.cloneChoice(choice);
            }
        }
        return choices;
    }

    cloneChoice(choice:ModelFactoryChoice):ModelFactoryChoice
    {
        return choice.clone()
    }

    initChoiceOrder()
    {

    }

    requireChoiceOrder(): void
    {
        if(this.choiceOrder.length){
            return;
        }
        let choiceOrder = [];
        for(let choiceID in this.choices) {
            let choice:ModelFactoryChoice = this.choices[choiceID];
            choiceOrder.push(choice.id);
        }
        this.choiceOrder = choiceOrder;
    }

    applyChoice(choice: ModelFactoryChoice): void
    {
        choice.factoryID = this.factoryID;
    }

    service(): ModelFactoryService
    {
        return getModelFactory().getService(this.factoryID) as ModelFactoryService;
    }

    factory(): BasicModelFactory
    {
        return getModelFactory().getFactory(this.factoryID) as BasicModelFactory
    }

    onWillAppear(levelList: NavigationLevelVO[]): void
    {

    }

    destroy(){
        this.clearChoiceList();
        this.destroyed = true;
        this.afterDestroyed();
    }

    afterDestroyed(){

    }
}

export interface IModelFactoryModels
{
    [key: string]: ModelFactoryModel;
}